import { BadgeCheck, ShieldCheck, MapPin, FileCheck2 } from "lucide-react";
import { PageHero, SectionHeading } from "../components/SectionHeading";
import { CtaBand } from "../components/CtaBand";
import { useBrand } from "../context/BrandContext";
import { IMAGES } from "../data/content";

export default function About() {
  const b = useBrand();
  const creds = [
    { icon: BadgeCheck, label: "USDOT Number", value: b.usdot, id: "usdot" },
    { icon: FileCheck2, label: "MC Number", value: b.mc, id: "mc" },
    { icon: ShieldCheck, label: "Coverage", value: "Licensed & Insured", id: "insured" },
    { icon: MapPin, label: "Headquarters", value: `${b.city}, ${b.state}`, id: "hq" },
  ];
  return (
    <>
      <PageHero testid="about-hero" eyebrow="About & Licensing" title="A Caldwell company that moves the country" image={IMAGES.freight}
        sub="Licensed, insured and accountable for every vehicle we move." />
      <section className="py-20 md:py-28">
        <div className="container-x grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-7 space-y-6 text-slate-700 text-base md:text-lg leading-relaxed" data-testid="about-story">
            <SectionHeading eyebrow="Our story" title="Straight talk, careful hauling" />
            <p>{b.company} started in Caldwell, Idaho with a simple promise: treat every vehicle as if the buyer were standing next to the truck. That means honest pricing, realistic delivery windows, and a phone that gets answered.</p>
            <p>Today we coordinate open and enclosed car carriers, door-to-door delivery and general freight across the continental United States. Every shipment is reviewed by a coordinator before an invoice goes out, and every carrier we book is fully insured.</p>
            <p>We are proud to be part of the Treasure Valley, and prouder still of the customers who come back to us for their next move.</p>
          </div>
          <div className="lg:col-span-5 grid grid-cols-2 gap-px bg-slate-200 border border-slate-200" data-testid="about-credentials">
            {creds.map(({ icon: I, label, value, id }) => (
              <div key={id} className="bg-white p-6" data-testid={`about-cred-${id}`}>
                <I className="w-7 h-7 text-orange-600" strokeWidth={1.5} />
                <div className="mt-5 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{label}</div>
                <div className="mt-1 font-display font-bold uppercase text-slate-900 text-xl sm:text-2xl">{value}</div>
              </div>
            ))}
            <div className="col-span-2 bg-white p-6 text-sm text-slate-600 leading-relaxed">
              Registered with the Federal Motor Carrier Safety Administration (FMCSA). Verify our authority with USDOT {b.usdot} on the FMCSA SAFER system.
              <div className="mt-3 text-slate-700">{b.address_full}</div>
            </div>
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
